export default __webpack_public_path__ + "static/media/9-NikauMagic.1f58cc2b.jpeg";